<div class="scroll-container p-1" ref="manage_workflow">
    <div class="card-nav-tabs border-0 rounded-lg mt-1 ms-2">
        <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
                <ul class="nav nav-tabs" data-tabs="tabs">
                    <li
                    class="border rounded-lg me-2 nav-item"
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="[ active_tab === tab ? 'active' : 'inactive']"
                    @click="set_active_tab(tab)"
                    >
                    <a
                        class="text-decoration-none text-xs p-3 rounded-pill"
                        :class="active_tab === tab ? 'text-white' : 'text-dark'"
                        href="#profile"
                        data-toggle="tab"
                    >
                        {{ tab }}
                    </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
     <hr class="ms-2"/>
    <div class="card-body mt-2">
       
        <div v-if="active_tab === 'Unresolved'">
            <!-- Show message only when no unresolved requests -->
            <p v-if="unresolved_requests.length === 0" class="fw-bold text-xs">No unresolved requests yet</p>
            
            <!-- Email Cards -->
            <div class="card mb-3 border-0 shadow hover-card" v-for="(unresolved, index) in unresolved_requests" :key="index" @click="selected_unresolved_request(unresolved.id)">
                <div class="card-body px-3 py-2">
                    <div class="row align-items-center">
                        <div class="col-auto d-flex align-items-center">
                            <i class="fa-regular fa-envelope text-dark me-2 fs-5"></i>
                        </div>
                        <div class="col-2 text-truncate">
                            <strong class="text-xs">{{ unresolved.sender }}</strong>
                        </div>
                        <div class="col text-truncate">
                            <span class="text-xs">{{ unresolved.message }}</span>
                        </div>
                        <div class="col-auto">
                            <small class="text-muted text-xs">{{ unresolved.date }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <!-- Show message only when no resolved requests -->
            <p v-if="resolved_requests.length === 0" class="fw-bold text-xs">No resolved requests yet</p>
            
            <div class="card mb-3 border-0 shadow hover-card" v-for="(resolved, index) in resolved_requests" :key="index" @click="view_resolved_request(resolved.id)">
                <div class="card-body px-3 py-2">
                    <div class="row align-items-center">
                        <div class="col-auto d-flex align-items-center">
                            <i class="fa-regular fa-square-check primary-green fs-5 me-2"></i>
                        </div>
                        <div class="col-2 text-truncate">
                            <strong class="text-xs">{{ resolved.sender }}</strong>
                        </div>
                        <div class="col text-truncate">
                            <span class="text-xs">{{ resolved.message }}</span>
                        </div>
                        <div class="col-auto">
                            <small class="text-muted text-xs">{{ resolved.date }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>